import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiFactory = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M2 22V9.975L9 7V9L14 7V10H22V22H2ZM4 20H20V12H12V9.95L7 11.95V10L4 11.325V20ZM11 18H13V14H11V18ZM7 18H9V14H7V18ZM15 18H17V14H15V18ZM22 10H17L18 2H21L22 10Z" />
  </SvgWrapper>
);
